module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [(_vm.loading) ? _c('div', {
    attrs: {
      "id": "overlay"
    }
  }, [_c('div', {
    staticClass: "spinner"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Loading...")])]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "box box-info"
  }, [_c('form', [_c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "fromDate"
    }
  }, [_vm._v("From Date")]), _vm._v(" "), (!_vm.englishDateEnabled) ? _c('date-picker', {
    attrs: {
      "valueType": "format"
    },
    model: {
      value: (_vm.fromDate),
      callback: function($$v) {
        _vm.fromDate = $$v
      },
      expression: "fromDate"
    }
  }) : _c('InputMask', {
    staticClass: "nepali-calendar",
    attrs: {
      "mask": "9999-99-99",
      "type": "text",
      "id": "fromDate"
    },
    model: {
      value: (_vm.fromDate),
      callback: function($$v) {
        _vm.fromDate = $$v
      },
      expression: "fromDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "toDate"
    }
  }, [_vm._v("To Date")]), _vm._v(" "), (!_vm.englishDateEnabled) ? _c('date-picker', {
    attrs: {
      "valueType": "format"
    },
    model: {
      value: (_vm.toDate),
      callback: function($$v) {
        _vm.toDate = $$v
      },
      expression: "toDate"
    }
  }) : _c('input-mask', {
    staticClass: "nepali-calendar",
    attrs: {
      "mask": "9999-99-99",
      "type": "text",
      "id": "toDate"
    },
    model: {
      value: (_vm.toDate),
      callback: function($$v) {
        _vm.toDate = $$v
      },
      expression: "toDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2 p-mt-5"
  }, [_c('Button', {
    staticClass: "p-button-raised",
    attrs: {
      "label": "Search",
      "icon": "pi pi-search"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.searchItemMargin.apply(null, arguments)
      }
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-col-12"
  }, [_c('DataTable', {
    staticClass: "p-datatable-responsive p-datatable-gridlines",
    attrs: {
      "value": _vm.itemMarginData,
      "paginator": true,
      "rows": 100,
      "filters": _vm.filters,
      "rowsPerPageOptions": [100, 500, 1000],
      "data-key": "id"
    },
    scopedSlots: _vm._u([{
      key: "empty",
      fn: function() {
        return [_vm._v("No record found")]
      },
      proxy: true
    }])
  }, [_c('Column', {
    attrs: {
      "header": "S.N"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(sl) {
        return [_vm._v("\n                " + _vm._s(sl.index + 1) + "\n              ")]
      }
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Transaction Date",
      "sortable": true,
      "field": "transactionDate"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(slotProps) {
        return [_vm._v("\n                  " + _vm._s(_vm.formatDate(slotProps.data.transactionDate)) + "\n              ")]
      }
    }, {
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['transactionDate']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'transactionDate', $$v)
            },
            expression: "filters['transactionDate']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Transaction Date Nepali",
      "sortable": true,
      "field": "transactionDateNepali"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(slotProps) {
        return [_vm._v("\n                  " + _vm._s(_vm.formatDate(slotProps.data.transactionDateNepali)) + "\n              ")]
      }
    }, {
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['transactionDateNepali']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'transactionDateNepali', $$v)
            },
            expression: "filters['transactionDateNepali']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Account Name",
      "sortable": true,
      "field": "accountName",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['accountName']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'accountName', $$v)
            },
            expression: "filters['accountName']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Narration",
      "sortable": true,
      "field": "narration",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['narration']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'narration', $$v)
            },
            expression: "filters['narration']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Transaction Amount",
      "sortable": true,
      "field": "transactionAmount",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['transactionAmount']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'transactionAmount', $$v)
            },
            expression: "filters['transactionAmount']"
          }
        })]
      },
      proxy: true
    }, {
      key: "footer",
      fn: function() {
        return [_vm._v("\n                " + _vm._s(_vm.totalExpensesAmount.toFixed(2)) + "\n              ")]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Org Name",
      "sortable": true,
      "field": "orgName",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['orgName']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'orgName', $$v)
            },
            expression: "filters['orgName']"
          }
        })]
      },
      proxy: true
    }])
  })], 1)], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b3c9c2e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/analysisReport/expensesReport.vue
// module id = 2068
// module chunks = 0